import { Box, Stack, Typography } from '@mui/material';

import { Campaign, ABTestType } from 'domains/campaigns/types';
import EmailPreviewContent from 'domains/content/components/EmailPreviewContent/EmailPreviewContent';
import { isTemplate } from 'domains/content/types';
import useSenderProfile from 'hooks/queries/useSenderProfile';
import useTemplate from 'hooks/queries/useTemplate';

type WinnerPreviewStepProps = {
    campaign: Campaign;
};

const WinnerPreviewStep = ({ campaign }: WinnerPreviewStepProps) => {
    // Determine which send to preview
    const isContentTest = campaign.abTestConfig?.testOn === ABTestType.CONTENT;
    const winnerSendId = campaign.abTestConfig?.winnerSendId;

    // For content tests, show the winner email
    // For send-time tests, show the first send (both have same content)
    const previewSend = isContentTest
        ? campaign.sends.find((send) => send.id === winnerSendId) || campaign.sends[0]
        : campaign.sends[0];

    const templateId = previewSend?.emailTemplateId;
    const senderProfileId = previewSend?.emailSenderProfileId;

    // Fetch data for the email
    const { data: previewTemplate } = useTemplate({
        templateId: `${templateId}`,
        reactQueryOptions: {
            enabled: !!templateId,
        },
    });

    const { data: emailSenderProfile } = useSenderProfile(senderProfileId, {
        enabled: !!senderProfileId,
    });

    return (
        <Stack spacing={2} height="100%">
            <Typography variant="body1">
                Review the {isContentTest ? 'winning ' : ''}content before sending to the rest of your audience.
            </Typography>

            {/* Email Preview Content */}
            <Box
                sx={{
                    flex: 1,
                    overflow: 'auto',
                    border: '1px solid',
                    borderColor: 'divider',
                    borderRadius: '8px',
                    maxHeight: '500px',
                }}
            >
                <EmailPreviewContent
                    isOpen={true}
                    onClose={() => {}}
                    emailTemplateHTML={isTemplate(previewTemplate) && previewTemplate.html}
                    fromAddress={emailSenderProfile?.from_address}
                    isCloseEnabled={false}
                    isGridItem={false}
                    preHeader={previewSend?.preHeader}
                    subjectLine={previewSend?.subjectLine}
                    sx={{ border: 'none', boxShadow: 'none', height: 'auto' }}
                />
            </Box>
        </Stack>
    );
};

export default WinnerPreviewStep;
